import { useState, useEffect } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import useWrapper from "../../hooks/useWrapper";
import useFormat from "../../hooks/utils/useFormat";
import Button from "../Button";
import Slct from "../Slct";
import ModalCustom from "./modal-template-default";
import Required from "../Required";
import { validateForm } from "../ValidateForm";
import usePermission from "../../hooks/usePermission";

/**
 * Remove (soft-delete) um Bônus/Promoção do formando, fora do modal grande de
 * renegociação. Remover um bônus AUMENTA o valor devido — a diferença é gerada
 * no passo seguinte pelo modal "Gerar Diferença".
 *
 * Usa PUT com `disabled: true` em vez de DELETE: é o caminho que o resto do
 * sistema já exercita, o registro fica no histórico, e o payload parcial evita
 * regravar `value`/`description` com dados velhos da tela.
 */
const ModalDiscountRemove = props => {
  const { show, onHide, discounts = [], refreshCallback } = props;
  const { config } = useWrapper();
  const { formatReal } = useFormat();
  const canUpdate = usePermission("financialGroup", "update");

  const [discountId, setdiscountId] = useState();
  const [isWaitingResponse, setisWaitingResponse] = useState(false);

  useEffect(() => {
    if (show) setdiscountId();
  }, [show]);

  const closeModal = () => {
    if (isWaitingResponse) return;
    onHide();
  };

  const _selected = discounts?.find(__discount => __discount.id === discountId);

  const removeDiscount = async () => {
    if (!canUpdate) return;
    const _is_valid = validateForm(document.getElementById("discount_remove_container"));
    if (!_is_valid) return;

    setisWaitingResponse(true);
    try {
      await api.put(`discount-trainee/${discountId}`, { disabled: true }, config);
      toast.success("Bônus removido!");
      onHide();
      refreshCallback && refreshCallback();
    } catch (__err) {
      const _message = __err?.response?.data?.error?.message;
      toast.error(_message || "Problemas ao remover o bônus!");
      console.error("__err", __err);
    } finally {
      setisWaitingResponse(false);
    }
  };

  return (
    <ModalCustom show={show} onHide={closeModal} id="discount_remove_container" disableClose={isWaitingResponse}>
      <ModalCustom.Header>
        <ModalCustom.Title>Remover Bônus ou Promoção</ModalCustom.Title>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <p className="small-label mb-2">
          Remover um bônus <b>aumenta</b> o valor devido pelo formando. O registro continua no histórico (não é
          apagado) e, ao confirmar, você poderá gerar os boletos da diferença.
        </p>
        <div className="mt-2">
          <span>
            Bônus a remover <Required />
          </span>
          <Slct
            required={true}
            isDisabled={isWaitingResponse}
            options={discounts?.map(__discount => ({
              value: __discount.id,
              label: `${__discount.description} — ${formatReal(__discount?.value || 0)}`,
            }))}
            value={discountId}
            onChange={__ev => setdiscountId(__ev.value)}
            placeholder="Selecione..."
          />
        </div>
        {!!_selected && (
          <p className="mt-3 mb-0">
            Impacto no valor devido:{" "}
            <b style={{ color: "var(--color-success)" }}>+ {formatReal(_selected?.value || 0)}</b>
          </p>
        )}
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button disabled={isWaitingResponse} color="primary_ghost" onClick={closeModal}>
          Cancelar
        </Button>
        <Button
          color="error"
          disabled={isWaitingResponse || !canUpdate || !discountId}
          onClick={removeDiscount}
          loading={isWaitingResponse}
        >
          Remover Bônus
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
};

export default ModalDiscountRemove;
